export default __webpack_public_path__ + "static/media/login_logo.e8dac978.png";